import {
  anchorHit,
  cardScore,
  gradeLeg,
  type FixtureResult,
  type Prediction
} from '@h2h/shared';

/** The single source of truth for "is this a PERFECT MATCH / Perfect card?".
 *  We only celebrate a card when the player actually took on risk: the 1X2 base
 *  landed AND at least one gradeable boost was stacked AND every one of those
 *  boosts hit. `attempted` counts the base (1) plus each *gradeable* boost, so
 *  `attempted > 1` means ≥1 boost truly graded — a bare correct base (no boosts,
 *  or only void boosts) is a win, not a "perfect card". */
export function isPerfectCard(correct: number, attempted: number): boolean {
  return attempted > 1 && correct === attempted;
}

/** Grade one settled card the same way the engine does (Build-Your-Card §7): the
 *  signed card score, plus the correct/attempted tally over the 1X2 base and every
 *  gradeable boost, and whether the card is a PERFECT MATCH (see `isPerfectCard`). */
export function gradePick(pick: Prediction, result: FixtureResult): {
  points: number;
  correct: number;
  attempted: number;
  perfect: boolean;
} {
  const baseHit = anchorHit(pick, result);
  let correct = baseHit ? 1 : 0;
  let attempted = 1;
  for (const leg of pick.legs ?? []) {
    const g = gradeLeg(leg, result);
    if (!g.gradeable) continue;
    attempted++;
    if (g.hit) correct++;
  }
  return { points: cardScore(pick, result), correct, attempted, perfect: isPerfectCard(correct, attempted) };
}
